import { IUser } from './user.interface';

export interface ILoginResponse {
  isAuthenticated: boolean;
  refreshToken: string;
  token: string;
  user: IUser;
  twoFAEnabled?: boolean;
  twoFASessionToken?: string;
}

export enum LoginResponseStatusEnum {
  SUCCESS = 1,
  USER_INACTIVE = 2,
  USER_NOT_EXIST = 3,
  INCORRECT_LOGIN_DATA = 4,
  USER_NOT_REGISTERED = 5,
  NO_MAIN_ACCOUNT_AVAILABLE = 6,
  INVITATION_EXPIRED = 7,
}

export interface ILoginErrorResponse {
  responseStatus: LoginResponseStatusEnum;
}

export enum TwoFactorProviderEnum {
  AUTHENTICATOR = 1,
  EMAIL = 2,
  BACKUP_CODE = 3,
}

export interface ILoginTwoFactorRequired {
  twoFactorRequired: true;
  sessionToken: string;
}

export interface ITwoFactorVerifyRq {
  code: string;
  sessionToken: string;
  provider: TwoFactorProviderEnum;
}

export interface ITwoFactorEmailSendResponse {
  success: boolean;
}
